<div class="free-confirm-wrapper">
  <p class="free-confirm-icon">👋</p>
  <p class="See-you-soon"> {{'see-you-soon.Soon' | translate}} </p>
  <p class="You-permantly-left">{{'see-you-soon.permanently' | translate}} {{ data.ps_name }}</p>
  <ion-button class="go-to-syndicate-btn" (click)="GotoSyndicates()"><span class="btn-text">{{'see-you-soon.Syndicates'
      | translate}}</span>
  </ion-button>
</div>